var version = {
    "name":      "dativery",
    "buildDateCode": "20261030-145258",
    "buildDate": "Fri Oct 30 2026 14:52:58 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261030-145258",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;